import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import { networks } from '../config/settings'; // Import the network settings
import tokenABI from '../abi/ADBYTES.json'; // Import the token ABI

const POLLING_INTERVAL = 10000; // Polling interval in milliseconds (e.g., 10000ms = 10s)

const MyBalance = () => {
  const [tokenName, setTokenName] = useState('');
  const [erc20Balance, setErc20Balance] = useState('0');
  const [nativeBalance, setNativeBalance] = useState('0');
  const [currentNetwork, setCurrentNetwork] = useState('');

  useEffect(() => {
    const web3 = window.ethereum ? new Web3(window.ethereum) : null;
    let pollingInterval;

    const loadBalances = async () => {
      if (!web3) return;

      const accounts = await web3.eth.getAccounts();
      if (accounts.length === 0) return;

      const networkId = await web3.eth.net.getId();
      const hexNetworkId = `0x${networkId.toString(16)}`;
      setCurrentNetwork(hexNetworkId);

      const network = Object.values(networks).find(net => net.chainId === hexNetworkId);
      if (!network) {
        console.error('Unsupported network');
        return;
      }

      const tokenAddress = network.contractAddress;
      const tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
      const tokenName = await tokenContract.methods.name().call();
      setTokenName(tokenName);

      const balance = await tokenContract.methods.balanceOf(accounts[0]).call();
      setErc20Balance(new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(web3.utils.fromWei(balance, 'ether'))));

      const nativeBalanceWei = await web3.eth.getBalance(accounts[0]);
      setNativeBalance(new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(web3.utils.fromWei(nativeBalanceWei, 'ether'))));
    };

    if (web3) {
      loadBalances();

      window.ethereum.on('accountsChanged', loadBalances);
      window.ethereum.on('chainChanged', (_, isInit) => {
        if (!isInit) window.location.reload();
      });

      // Set up polling interval to refresh the balance
      pollingInterval = setInterval(loadBalances, POLLING_INTERVAL);
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', loadBalances);
        window.ethereum.removeListener('chainChanged', loadBalances);
      }
      clearInterval(pollingInterval); // Clear the polling interval on component unmount
    };
  }, []);

  const network = Object.values(networks).find(net => net.chainId === currentNetwork);

  // Determine the "Buy & Sell" link URL based on the network
  let buySellLink = '#';
  if (currentNetwork === '0x89') { // Polygon network
    buySellLink = 'https://app.uniswap.org/swap?chain=polygon&inputCurrency=0xc2132d05d31c914a87c6611c10748aeb04b58e8f&outputCurrency=0x75beEbcc19e17560Ec92bfB4A52854135126B1d8';
  } else if (currentNetwork === '0xa86a') { // Avalanche network
    buySellLink = 'https://traderjoexyz.com/avalanche/trade?inputCurrency=0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7&outputCurrency=0x7Ce47348F20D6bb03B995867251AA8eB4807d123';
  }

  return (
    <div className="token-card bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between">
      <div>
        <h3 className="text-xl font-semibold mb-4">My Balance</h3>
        <p className="text-lg">{erc20Balance} {tokenName}</p>
        <p className="text-lg mb-4">{nativeBalance} {network?.nativeCurrency.symbol}</p>
      </div>
      <div>
        <p className="text-sm mb-4">Note: Balance does not include your unclaimed platform rewards.</p>
        <div className="flex space-x-2">
          <a href="/publisher/redeem" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700">Claim Rewards</a>
          <a href={buySellLink} target="_blank" rel="noopener noreferrer" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700">Buy & Sell</a>
        </div>
      </div>
    </div>
  );
};

export default MyBalance;
